<div class="combo-box-selected-item {{CompatibilityService.LegacyFlexElement}}">
    {{getItemDisplay(Item)}}
    <div *ngIf="ShowRemoveItem == true" class="{{CompatibilityService.LegacyFlexElement}}">
        <pm-icon-times-circle  class="{{CompatibilityService.LegacyFlexElement}}" [style.padding-left.px]="3" (click)="removeItem()"></pm-icon-times-circle>        
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/boxes/combo-box/combo-selected-item.html